import { notificationsActionTypes } from './notifications.types';

const initialState = {
    items: [],
    unreadCount: 0,
    lastSyncedAt: null,
};

function countUnread(items) {
    let n = 0;
    for (const it of items) if (!it.readAt) n += 1;
    return n;
}

export default function notificationsReducer(state = initialState, action) {
    switch (action.type) {
        case notificationsActionTypes.NOTIFICATIONS_SYNCED: {
            const items = action.payload.items || [];
            return { items, unreadCount: countUnread(items), lastSyncedAt: Date.now() };
        }
        case notificationsActionTypes.NOTIFICATION_RECEIVED: {
            const { item } = action.payload;
            if (state.items.some((i) => i.id === item.id)) return state;
            const items = [item, ...state.items];
            return { ...state, items, unreadCount: countUnread(items) };
        }
        case notificationsActionTypes.NOTIFICATION_MARK_READ: {
            const { notificationId } = action.payload;
            const existing = state.items.find((i) => i.id === notificationId);
            if (!existing || existing.readAt) return state;
            const items = state.items.map((i) =>
                i.id === notificationId ? { ...i, readAt: Date.now() } : i
            );
            return { ...state, items, unreadCount: countUnread(items) };
        }
        case notificationsActionTypes.NOTIFICATIONS_RESET:
            return initialState;
        default:
            return state;
    }
}
